var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseNotas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9968 10.586L16.9468 5.63599L18.3608 7.04999L13.4108 12L18.3608 16.95L16.9468 18.364L11.9968 13.414L7.04681 18.364L5.63281 16.95L10.5828 12L5.63281 7.04999L7.04681 5.63599L11.9968 10.586Z",
    fill: "#002856"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseNotas);
export default __webpack_public_path__ + "static/media/closeNotas.2911ca352fae8b750818a9c39c2571ff.svg";
export { ForwardRef as ReactComponent };